import BottomHeader from './BottomHeaderContainer';

export default BottomHeader;